import {StepperConfig} from '../../../../../projects/mydocma/import-export/src/lib/stepper/stepper.config';

export const stepperConfig: StepperConfig = {
    steps: [{
        name: 'selectFile',
        label: 'import-stepper.selectFile',
        icon: {
            number: 'gavel',
            edit: 'gavel',
            done: 'gavel'
        },
        optional: false,
        editable: true,
        enabled: true
    },
    {
        name: 'fileDataMapping',
        label: 'import-stepper.fileDataMapping',
        icon: {
            number: 'image',
            edit: 'image',
            done: 'image'
        },
        optional: false,
        editable: true,
        enabled: false
    },
    {
        name: 'filePreview',
        label: 'import-stepper.filePreview',
        icon: {
            number: 'place',
            edit: 'place',
            done: 'place'
        },
        optional: false,
        editable: true,
        enabled: false
    },
    {
        name: 'dataResult',
        label: 'import-stepper.step4',
        icon: {
            number: 'done',
            edit: 'done',
            done: 'done'
        },
        optional: false,
        editable: true,
        enabled: false
    }]
};
